import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

interface CustomProps extends React.HTMLAttributes<HTMLDivElement> {
    top?: boolean;
    multi?: boolean;
  }

export const RolesTableWrapper = styled.div`
    width: 100%;
`

export const RolesTableLabel = styled.div`
    font-size:12px;
    color: ${theme.colors.dkgrey};
    font-family:"Poppins";
`

export const RoleTable = styled.div`
    display: flex;
    width: 100%;
    margin-top: 10px;
    border: 1px solid ${theme.colors.inputOutline};
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
`

export const RoleLinkWrapper = styled.div`
    width: 200px; 
    flex-shrink: 0; 
    padding-top:30px;
    border-right: 1px solid ${theme.colors.inputOutline};
`

export const RoleSelectWrapper = styled.div`
    flex:1;
    padding-top:40px;
    padding-left:30px;
    height:calc(100vh - 525px);
    overflow:scroll;
    padding-right:30px;
    min-height:200px;
`

export const RoleLink = styled.div<CustomProps>`
    display:flex;
    padding-top:13px;
    padding-bottom:13px;
    padding-right:30px;
    justify-content:flex-end;
    width:100%;
    font-family:"Poppins";
    font-size:14px;
    font-weight:500;
    border-right: 2px solid transparent;
    color: ${theme.colors.dkgrey};
   &.active {
        color: ${theme.colors.black};
        background: ${theme.colors.inputOutline};
        border-right: 2px solid black;
    }
    cursor:pointer;
`

export const ModelTitle = styled.div`
    font-size:16px;
    font-family:"Poppins";
    font-weight:600;
    display:flex;
    width:100%;
`

export const RoleGroup = styled.div`
  padding-bottom:40px;
  display:flex;
`

export const RoleSelectInner = styled.div`
  padding-top:40px;
`

export const RoleGroupTitle = styled.div<CustomProps>`
  width: 100px;
  flex-shrink: 0;
  display:flex;
  justify-content:flex-end;
  font-family:"Poppins";
  font-size:14px;
  font-weight:600;
  padding-top:${props => props.multi ? "10px" : "0px"};
`


export const RoleGroupOptions = styled.div`
  width: 100%;
  margin-left:30px;
`

export const RolesTableFooter = styled.div`
    display:flex;
    justify-content:flex-end;
    padding-top:30px;
    border-left: 1px solid ${theme.colors.inputOutline};
    border-right: 1px solid ${theme.colors.inputOutline};
    border-bottom: 1px solid ${theme.colors.inputOutline};
    padding:20px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
`

export const PermissionSection = styled.div`
    width:100%;
`

export const BasicRoleInputs = styled.div`
  display:flex;
  gap:20px;
`

export const RoleCheckWrapper = styled.div<CustomProps>`
  display:flex;
  flex-direction:row;
  width:100%;
   > div {
    border-top: ${props => props.top ? "1px solid " + theme.colors.inputOutline : "none"};
    border-bottom: 1px solid ${theme.colors.inputOutline};
    padding-top:10px;
    padding-bottom:5px;
 }
`

export const PermissionDescription = styled.div`
    font-size:14px;
    color: ${theme.colors.dkgrey};
    font-family:"Poppins";
`


